import { Component, ElementRef, Inject, Input, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { Location, NgIf, NgClass, NgFor, AsyncPipe } from '@angular/common';
import {
  ApiService,
  CoreUiPartialState,
  DialogService,
  getOrderTypes,
  getUserName,
  getUserRole,
  hasUnsavedChanges,
  isExternalUser,
  MessageService,
} from '@pos-app/core-ui';
import { AttachmentEntityType } from '@pos-app/data/lib/models/attachment';
import { ToastrService } from 'ngx-toastr';
import { TaskDetail } from '../../../../model/task';
import { ColumnApi, GridApi, GridOptions } from 'ag-grid-community';
import { CentralPartialState } from '../../../../+state/central.reducer';
import { select, Store } from '@ngrx/store';
import { centralQuery } from '../../../../+state/central.selectors';
import { distinctUntilChanged, finalize, map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { FetchSalesPeopleList, FetchSiteList, LoadTaskDetails } from '../../../../+state/central.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { OrderType } from '@pos-app/data';
import { CustomersPartialState } from '../../../../../customers/+state/customers.reducer';
import { FetchJdeOrder } from '../../../../../orders/+state/orders.actions';
import { AngularEditorConfig, AngularEditorModule } from '@kolkov/angular-editor';
import { getFullYearLocaleDate, getLocalLocaleDate } from '@pos-app/core-ui/lib/utils/utils-date';
import { CentralTaskGridActionRendererComponent } from './CentralTaskGridActionRendererComponent';
import { CoreUiModule } from '../../../../../../../../../../libs/core-ui/src/lib/core-ui.module';
import { TaskNavComponent } from '../task-nav/task-nav.component';
import { AgGridModule } from 'ag-grid-angular';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';

@Component({
    selector: 'app-central-task-detail',
    templateUrl: './task-detail.component.html',
    styleUrls: ['./task-detail.component.scss'],
    imports: [CoreUiModule, NgIf, TaskNavComponent, NgClass, FormsModule, AgGridModule, ReactiveFormsModule, NgSelectComponent, NgFor, NgOptionComponent, AngularEditorModule, AsyncPipe]
})
export class TaskDetailComponent implements OnInit {
  @ViewChild('content') boxModel: ElementRef;
  @ViewChild('siteInput') siteInput!: ElementRef;
  @ViewChild('assignedToInput') assignedToInput!: ElementRef;
  @Input() newTask: boolean;
  @Input() sourceSite: string;
  @Input() taskRaisedBy: string;
  @Input() orderDetails: any;

  UKID: number = this.route.snapshot.params.id;
  skipNewTaskURL: boolean = this.location.path().includes('latest') ? true : false;
  searchValue: string = '';
  frameworkComponents;
  context;
  rowData = [];
  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  gridOptionsHistory: GridOptions;
  taskDetail: TaskDetail;
  private unSubscribe$ = new Subject<void>();

  //forms
  changeAssigneeForm: UntypedFormGroup;
  changeOrderForm: UntypedFormGroup;
  newOrderNumber: string = '';
  newOrderType: string = '';
  validChangeOrder: boolean = false;
  validateChangeOrder: boolean = false;
  validateChangeAssignee: boolean = false;
  isChangeOrder: boolean = false;
  isChangeAssignee: boolean = false;
  siteList$: any;
  loggedInUser: string;
  newComment: string = '';
  addCommentValid: boolean = false;
  initialFormValue: any;
  initialFormValueChangeOrder: any;
  initialFormValueChangeAssignee: any;
  formValid: boolean = false;
  isShowTaskHistory: boolean = false;
  rowDataHistory = [];
  isShowUser: boolean = false;
  isInternalUser: boolean = false;
  siteList: any;
  homeSite: string;
  siteListFiltered: any;
  salesPersonList: any;
  orderTypes: OrderType[];
  isShowTaskAttachments: boolean = false;
  entityId: string;
  entityType: AttachmentEntityType;
  public loading$ = new BehaviorSubject<boolean>(false);
  allAttachments: any[];
  editorConfig: AngularEditorConfig;
  isUpdateComment: boolean = false;
  isAddComment: boolean = false;
  commentForm: UntypedFormGroup;
  initialCommentValue: any;
  initialCommentValueId: number;
  isCloseTask: boolean;
  isReOpenClosedTask: boolean;
  linkOrderCustomerName: string;
  linkOrderCustomerNumber: number;
  initialLinkedOrderNumber: number;
  userEmail$: Observable<string>;
  site$: Observable<string>;
  isBusy$: Observable<boolean>;
  isAutoSave: boolean;
  initialLoad: boolean = true;
  activeNavIndex = 1;
  userSite: any;

  constructor(
    private apiService: ApiService,
    private toastr: ToastrService,
    private store: Store<CentralPartialState>,
    private storeCore: Store<CoreUiPartialState>,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private messageService: MessageService,
    private dialogService: DialogService,
    private location: Location,
    private customerStore: Store<CustomersPartialState>,
    private router: Router,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.frameworkComponents = {
      actionRenderer: CentralTaskGridActionRendererComponent,
    };
    this.context = { componentParent: this };
    this.gridOptions = this.gridOptionsData();
    this.gridOptionsHistory = this.gridOptionsHistoryData();

    this.editorConfig = {
      editable: true,
      spellcheck: false,
      height: '5rem',
      minHeight: '5rem',
      placeholder: 'Enter comment here...',
      translate: 'no',
      defaultParagraphSeparator: 'p',
      toolbarHiddenButtons: [
        ['fontName', 'heading'],
        [
          'fontSize',
          'textColor',
          'backgroundColor',
          'customClasses',
          'link',
          'unlink',
          'insertImage',
          'insertVideo',
          'insertHorizontalRule',
          'toggleEditorMode',
        ],
      ],
    };
  }

  ngOnInit() {
    this.initializeForms();
    this.store.dispatch(new FetchSiteList());
    this.store.dispatch(new FetchSalesPeopleList());

    if (this.newTask) {
      this.initialLoad = false;
    } else {
      this.newTask = false;
      this.initialLoad = true;
      this.apiService.fetchUserSite().subscribe((data) => {
        this.userSite = data;
        this.changeAssigneeForm.patchValue({ site: this.userSite?.sourceSiteCode }, { emitEvent: false });
      });
    }

    this.isBusy$ = this.store.select(centralQuery.getIsBusy);

    this.storeCore
      .pipe(select(getOrderTypes))
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.orderTypes = data;
      });

    this.storeCore
      .pipe(select(isExternalUser))
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.isInternalUser = false;
      });
    this.storeCore
      .select(getUserRole)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.isShowUser = data && data.includes('SHOW');
      });
    this.store
      .pipe(select(centralQuery.getSiteListData))
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.siteList = data.siteList;
        this.homeSite = data.homeSite;
        this.siteListFiltered = this.siteList?.filter((site) => site.siteType === 'ARB');
      });

    if (this.newTask) {
      this.formValid = true;
    } else {
      this.store
        .select(centralQuery.getTaskDetails)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          this.taskDetail = data;

          if (data) {
            if (this.initialLoad && Number(this.UKID) === data.UKID) {
              this.getTaskAttachment();
              this.initialLoad = false;
            }
            this.rowDataHistory = this.taskDetail.ticketHistory;
            if (this.loggedInUser) {
              this.rowData = this.taskDetail.comments.map((comment) => ({
                ...comment,
                loggedInUser: this.loggedInUser,
              }));
            }
            // PBI-4426, if date change and due date is empty or in past

            this.initialLinkedOrderNumber = this.taskDetail?.orderNumber;
            this.changeOrderForm?.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$)).subscribe((val) => {
              this.compareValuesChangeOrdeForm();
            });
            this.changeOrderForm?.patchValue({
              newOrderNumber: this.taskDetail?.orderNumber < 1 ? '' : this.taskDetail?.orderNumber.toString(),
              newOrderType: this.taskDetail?.orderType,
            });
            this.initialFormValueChangeOrder = this.changeOrderForm?.getRawValue();
          }
        });

      if (!this.taskDetail) {
        this.store.dispatch(new LoadTaskDetails(this.UKID));
      }
    }

    this.storeCore
      .pipe(select(getUserName))
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.loggedInUser = data;
      });
    this.store
      .pipe(select(centralQuery.getSalesPersonList))
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.salesPersonList = data;
      });

    this.initialFormValueChangeOrder = this.changeOrderForm.getRawValue();

    this.changeOrderForm
      .get('newOrderNumber')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        if (val === this.initialLinkedOrderNumber) {
          this.validChangeOrder = true;
          return;
        }
        this.validChangeOrder = false;
      });

    this.changeOrderForm
      .get('newOrderType')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        this.validChangeOrder = false;
      });

    this.changeAssigneeForm
      .get('storeType')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        if (val === '0') {
          this.siteListFiltered = this.siteList.filter((site: any) => site.siteType === 'ARB');
          if (this.siteList?.find((site) => site.siteCode === this.taskDetail?.siteAssigned).siteType === 'ARB') {
            this.changeAssigneeForm.get('site').setValue(this.taskDetail?.siteAssigned);
            this.changeAssigneeForm.get('assignedTo').setValue(this.taskDetail?.assignedToName);
          } else {
            this.changeAssigneeForm.get('site').setValue('');
          }
        } else {
          this.siteListFiltered = this.siteList.filter((site: any) => site.siteType !== 'ARB');
          if (this.siteList?.find((site) => site.siteCode === this.taskDetail?.siteAssigned).siteType !== 'ARB') {
            this.changeAssigneeForm.get('site').setValue(this.taskDetail?.siteAssigned);
            this.changeAssigneeForm.get('assignedTo').setValue(this.taskDetail?.assignedToName);
          } else {
            this.changeAssigneeForm.get('site').setValue('');
          }
        }
      });

    this.changeAssigneeForm
      .get('site')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        const assigneeControl = this.changeAssigneeForm.get('assignedTo');
        if (val) {
          this.changeAssigneeForm.get('siteDescription').setValue(this.siteList?.find((el) => el.siteCode === val)?.siteDescription);
        } else {
          this.changeAssigneeForm.get('siteDescription').setValue('');
        }
        if (val === this.homeSite) {
          assigneeControl.enable();
        } else {
          assigneeControl.disable();
          this.changeAssigneeForm.get('assignedTo').setValue('');
        }
      });

    this.changeAssigneeForm
      .get('assignedTo')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        if (val) {
          this.changeAssigneeForm.get('assignedToName').setValue(this.salesPersonList.find((el) => el.userEmail === val)?.name);
        } else {
          this.changeAssigneeForm.get('assignedToName').setValue('');
        }
      });
  }

  private initializeForms() {
    this.changeAssigneeForm = new UntypedFormGroup({
      assignedTo: new UntypedFormControl(''),
      assignedToName: new UntypedFormControl(''),
      storeType: new UntypedFormControl('0', Validators.required),
      site: new UntypedFormControl('', Validators.required),
      siteDescription: new UntypedFormControl(''),
    });

    this.changeOrderForm = new UntypedFormGroup({
      newOrderNumber: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      newOrderType: new UntypedFormControl('', Validators.required),
    });

    this.commentForm = new UntypedFormGroup({
      comment: new UntypedFormControl('', Validators.required),
    });
  }

  compareValuesChangeOrdeForm() {
    const currentFormValue = this.changeOrderForm.getRawValue();
    if (JSON.stringify(currentFormValue) !== JSON.stringify(this.initialFormValueChangeOrder)?.toString()) {
      this.validateChangeOrder = true;
    } else {
      this.validateChangeOrder = false;
    }
  }

  compareValuesChangeAssigneeForm() {
    const currentFormValue = this.changeAssigneeForm.getRawValue();
    if (JSON.stringify(currentFormValue) !== JSON.stringify(this.initialFormValueChangeAssignee)?.toString()) {
      this.validateChangeAssignee = true;
    } else {
      this.validateChangeAssignee = false;
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    const sortModel = [{ colId: 'dateTime', sort: 'desc' }];
    this.gridApi.resetRowHeights();
  }

  onCellClicked(event) {
    if (event.colDef.field === 'text') {
      const rowNode = event.node;
      const isExpanded = rowNode.expanded;
      rowNode.setExpanded(!isExpanded);
    }
  }

  gridOptionsData() {
    return {
      defaultColDef: {
        resizable: true,
        sortable: true,
        width: 150,
        cellClass: 'cell-class ag-right-aligned-cell',
        headerClass: 'header-class ag-left-aligned-header',
        cellStyle: {},
        wrapText: true,
        autoHeight: true,
      },
      columnDefs: [
        {
          headerName: 'ACTION',
          width: 100,
          cellRenderer: 'actionRenderer',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'User',
          field: 'user',
          width: 200,
          cellStyle: { 'text-align': 'left', 'text-transform': 'none' },
          cellRenderer: (params) => {
            return `<div> ${params.value}<br/><small>${params.data.site ? `(${params.data.site})` : ''}</small></div>`;
          },
        },
        {
          headerName: 'Comments',
          field: 'text',
          flex: 1,
          cellStyle: { 'text-align': 'left', 'text-transform': 'none' },
          cellRenderer: (params) => {
            const div = document.createElement('div');
            div.innerHTML = params.value;
            return div;
          },
        },
        {
          headerName: ' Date',
          field: 'dateCreated',
          width: 230,
          cellStyle: { 'text-align': 'left', 'text-transform': 'none' },
          cellRenderer: (params) => {
            return `<div><small>Created:  ${getLocalLocaleDate(params.data.dateCreated, this.locale)}${this.dateFormatter(
              params.data.dateCreated
            )}</small><br/><small>${
              params.data.dateModified
                ? `(Modified: ${this.getLocalLocaleDate(params.data.dateModified, this.locale)}${this.dateFormatter(params.data.dateCreated)})`
                : ''
            }</small></div>`;
          },
          // cellRenderer: (params) => {
          //   return `<div><small>Created: ${this.dateFormatter(params.data.dateCreated)}</small><br/><small>${
          //     params.data.dateModified ? `(Modified: ${this.dateFormatter(params.data.dateModified)})` : ''
          //   }</small></div>`;
          // },
        },
      ],
    };
  }

  getLocalLocaleDate(dateString: string, locale: string) {
    if (dateString?.trim()?.includes('/')) {
      const date = dateString.split('/');

      return getFullYearLocaleDate(locale, {
        day: parseInt(date[0], 10),
        monthIndex: parseInt(date[1], 10) - 1,
        year: parseInt(date[2], 10),
      });
    }

    if (dateString?.trim().includes('-')) {
      const date = new Date(dateString);

      return getFullYearLocaleDate(locale, {
        day: date.getDate(),
        monthIndex: date.getMonth(),
        year: date.getFullYear(),
      });
    }

    return null;
  }
  editTaskComment(rowIndex: number, colKey: string) {
    this.isUpdateComment = true;
    this.initialCommentValue = this.rowData[rowIndex].text || '';
    this.initialCommentValueId = this.rowData[rowIndex].id;
    this.commentForm.patchValue({ comment: this.rowData[rowIndex].text });
    this.openModalBox();
  }

  addCommentToTask() {
    this.isAddComment = true;
    this.openModalBox();
  }

  gridOptionsHistoryData() {
    return {
      defaultColDef: {
        resizable: true,
        sortable: true,
        width: 150,
        cellClass: 'cell-class ag-right-aligned-cell',
        headerClass: 'header-class ag-left-aligned-header',
        cellStyle: {},
        wrapText: true,
        autoHeight: true,
      },
      columnDefs: [
        {
          headerName: ' Date',
          field: 'date',
          width: 230,
          cellRenderer: (params) => {
            return `${getLocalLocaleDate(params.value, this.locale)} ${this.dateFormatter(params.value)}`;
          },

          cellStyle: { 'text-align': 'left', 'text-transform': 'none' },
        },

        {
          headerName: 'History',
          field: 'text',
          flex: 1,
          cellStyle: { 'text-align': 'left', 'text-transform': 'none' },
        },
      ],
    };
  }

  dateFormatter(params) {
    return moment(params).format('<HH:mm>');
  }
  openModalBox() {
    this.modalService
      .open(this.boxModel, {
        windowClass: 'garage-modal',
        size: 'xl',
        backdrop: 'static',
      })
      .result.then(
        (_) => {
          this.isChangeOrder = false;
          this.isChangeAssignee = false;
          this.isShowTaskHistory = false;
          this.isShowTaskAttachments = false;
          this.isAddComment = false;
          this.isUpdateComment = false;
          this.isCloseTask = false;
          this.isReOpenClosedTask = false;
        },
        (_) => {
          this.isChangeOrder = false;
          this.isChangeAssignee = false;
          this.isShowTaskHistory = false;
          this.isShowTaskAttachments = false;
          this.isAddComment = false;
          this.isUpdateComment = false;
          this.isCloseTask = false;
          this.isReOpenClosedTask = false;
        }
      );
  }

  showTaskHistory() {
    this.isShowTaskHistory = true;
    this.openModalBox();
  }

  // Method to check and open modal for changing order
  changeOrderCheck() {
    this.changeOrderForm.patchValue({
      newOrderNumber: this.taskDetail?.orderNumber < 1 ? '' : this.taskDetail?.orderNumber.toString(),
      newOrderType: this.taskDetail?.orderType,
    });
    this.initialFormValueChangeOrder = this.changeOrderForm.getRawValue();
    this.isChangeOrder = true;
    this.openModalBox();
  }

  // Method to check and open modal for changing assignee
  changeAssigneeCheck() {
    this.changeAssigneeForm?.patchValue(
      {
        assignedTo: this.taskDetail?.assignedToName,
        site: this.taskDetail?.siteAssigned,
        storeType: this.siteList?.find((site) => site.siteCode === this.taskDetail?.siteAssigned).siteType === 'ARB' ? '0' : '1',
      },
      { emitEvent: true }
    );
    this.initialFormValueChangeAssignee = this.changeAssigneeForm.getRawValue();
    this.changeAssigneeForm?.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$)).subscribe((val) => {
      this.compareValuesChangeAssigneeForm();
    });

    this.isChangeAssignee = true;
    this.openModalBox();
  }

  // Method to change assignee
  changeAssignee() {
    const objectToUpdate = {};

    for (const key in this.changeAssigneeForm.value) {
      if (this.changeAssigneeForm.value[key] !== '') {
        objectToUpdate[key] = this.changeAssigneeForm.value[key];
      }
    }
    objectToUpdate['siteDescription'] = this.siteList.find((el) => el.siteCode === this.changeAssigneeForm.value.site).siteDescription;
    objectToUpdate['UKID'] = Number(this.UKID);
    objectToUpdate['assignedTo'] = this.changeAssigneeForm.value.assignedTo || 'UNASSIGNED';
    objectToUpdate['assignedToName'] = this.changeAssigneeForm.value.assignedToName || 'UNASSIGNED';
    delete objectToUpdate['storeType'];

    this.apiService.maintainTask(objectToUpdate).subscribe((res) => {
      if (res?.ErrorFlag === '0') {
        this.toastr.success('Assignee Updated Successfully');
        this.changeAssigneeForm.reset();
        this.modalService.dismissAll();
        this.store.dispatch(new LoadTaskDetails(this.UKID));
      }
    });
  }

  // Method to validate order change
  validateForChangeOrder() {
    this.apiService
      .checkOrderExists({ orderNumber: this.changeOrderForm.value.newOrderNumber, orderType: this.changeOrderForm.value.newOrderType })
      .subscribe((res) => {
        if (res?.ErrorFlag === '0') {
          this.validChangeOrder = true;
          this.linkOrderCustomerName = res.customerName;
          this.linkOrderCustomerNumber = res.customerNumber;
        } else {
          this.validChangeOrder = false;
          this.linkOrderCustomerName = '';
        }
      });
  }

  // Method to remove order link
  removeOrderLink() {
    this.apiService
      .maintainTask({
        UKID: this.UKID,
        customerNumber: 0,
        orderNumber: 0,
        orderType: '',
      })
      .subscribe((res) => {
        if (res?.ErrorFlag === '0') {
          this.toastr.success('Removed linked order successfully');
          this.store.dispatch(new LoadTaskDetails(this.UKID));
          this.modalService.dismissAll();
        }
      });
  }

  // Method to change order number
  changeOrderNumber() {
    this.apiService
      .maintainTask({
        UKID: Number(this.UKID),
        customerNumber: Number(this.linkOrderCustomerNumber),
        orderNumber: Number(this.changeOrderForm.value.newOrderNumber),
        orderType: this.changeOrderForm.value.newOrderType,
      })
      .subscribe((res) => {
        if (res?.ErrorFlag === '0') {
          this.toastr.success('Order Number Updated Successfully');
          this.store.dispatch(new LoadTaskDetails(this.UKID));
          this.modalService.dismissAll();
        }
      });
  }

  // Method to add or update task comment
  addUpdateTaskComment() {
    if (this.isAddComment) {
      this.addTaskComment();
    } else if (this.isUpdateComment) {
      this.updateTaskComment();
    }
  }

  // Method to add task comment
  addTaskComment() {
    this.apiService
      .addTaskComment({
        UKID: this.UKID,
        comment: this.commentForm.get('comment').value.trim(),
      })
      .subscribe((res) => {
        if (res?.ErrorFlag === '0') {
          this.toastr.success('Comment Added Successfully');
          this.store.dispatch(new LoadTaskDetails(this.UKID));
          this.commentForm.reset();
          this.modalService.dismissAll();
        }
      });
  }

  // Method to update task comment
  updateTaskComment() {
    const commentData = {
      UKID: Number(this.UKID),
      comment: this.commentForm.get('comment').value.trim(),
      id: this.initialCommentValueId,
    };

    this.apiService.updateTaskComment(commentData).subscribe((res) => {
      if (res?.ErrorFlag === '0') {
        this.toastr.success('Comment Updated Successfully');
        this.store.dispatch(new LoadTaskDetails(this.UKID));
        this.commentForm.reset();
        this.modalService.dismissAll();
      }
    });
  }

  // Method to open modal for closing task
  openCloseTaskModal() {
    this.commentForm.reset();
    this.isCloseTask = true;
    this.openModalBox();
  }

  // Method to open modal for reopening task
  openReopenTaskModal() {
    this.commentForm.reset();
    this.isReOpenClosedTask = true;
    this.openModalBox();
  }

  // Method to close task
  closeTask() {
    if (this.formValid) {
      this.isAutoSave = true;
      //this.saveTask(this.taskDetailForm.getRawValue());
    }
    const closeTaskData = {
      UKID: this.UKID,
      comment: this.commentForm.get('comment').value.trim(),
    };

    this.apiService.closeTask(closeTaskData).subscribe((res) => {
      if (res?.ErrorFlag === '0') {
        this.toastr.success('Task Closed Successfully');
        this.commentForm.reset();
        this.store.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
        this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));
        this.modalService.dismissAll();
        this.router.navigateByUrl('/central/tasks');
      }
    });
  }

  // Method to reopen task
  reopenTask() {
    const reopenTaskData = {
      UKID: this.UKID,
      comment: this.commentForm.get('comment').value.trim(),
    };

    this.apiService.reopenTask(reopenTaskData).subscribe((res) => {
      if (res?.ErrorFlag === '0') {
        this.toastr.success('Task Re-open Successfully');
        this.commentForm.reset();
        this.store.dispatch(new LoadTaskDetails(this.UKID));
        this.modalService.dismissAll();
      }
    });
  }

  // Method to save task
  saveTask(objectToUpdate) {
    this.formValid = true;
    if (!this.newTask) {
      objectToUpdate['UKID'] = Number(this.UKID);
    }

    this.apiService.maintainTask(objectToUpdate).subscribe((res) => {
      if (res?.ErrorFlag === '0') {
        this.toastr.success('Task Updated Successfully');
        this.formValid = false;
        this.store.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
        this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));

        this.newTask = false;
        if (this.isAutoSave) {
          this.router.navigateByUrl('/central');
        } else {
          this.store.dispatch(new LoadTaskDetails(Number(res.UKID)));
          this.router.navigateByUrl('/central/task/detail/' + res.UKID + '/latest');
        }
        this.modalService.dismissAll();
      }
    });
  }

  // Method to cancel and reset form
  cancel() {
    this.commentForm.reset();
    //this.taskDetailForm.patchValue(this.initialFormValue);
    this.formValid = false;
    this.store.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
    this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));
    //check previous url
    if (this.skipNewTaskURL) {
      this.skipNewTaskURL = false;
      this.location.historyGo(-2);
    } else {
      this.location.back();
    }
  }

  // Method to delete comment
  deleteComment(data) {
    return this.dialogService
      .confirm(
        `<p>Are you sure you want to delete this comment?</p>
        <p></p>`,
        `Delete Note`,
        'Delete',
        'Cancel',
        true,
        null,
        false
      )
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        if (val) {
          this.apiService.deleteTaskComment({ UKID: this.UKID, id: data.id }).subscribe((res) => {
            if (res?.ErrorFlag === '0') {
              this.toastr.success('Comment Deleted Successfully');
              this.store.dispatch(new LoadTaskDetails(this.UKID));
            }
          });
        }
      });
  }

  // Method to cancel and reset modal
  cancelModel() {
    this.commentForm.reset();
    this.changeOrderForm.reset();
    this.modalService.dismissAll();
  }

  // Method to show task attachments
  getTaskAttachment() {
    if (this.taskDetail) {
      this.entityType = 'crm';
      this.entityId = `${this.taskDetail?.UKID}`;
      this.apiService
        .getAttachments('crm', `${this.taskDetail.UKID}`)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((res) => {
          this.initialLoad = false;
          this.allAttachments = res;
        });
    }
  }

  showTaskAttachments() {
    this.isShowTaskAttachments = true;
    this.openModalBox();
  }

  // Method to handle modal close event
  handleCloseModal(event) {
    if (event) {
      this.modalService.dismissAll();
    }
  }

  // Method to fetch order from JDE
  fetchOrderFromJDE() {
    this.customerStore.dispatch(
      new FetchJdeOrder({
        orderNumber: this.newTask ? this.orderDetails?.orderNumber : this.taskDetail?.orderNumber,
        orderType: this.newTask ? this.orderDetails?.orderType : this.taskDetail?.orderType,
        JDEOrderType: this.newTask ? this.orderDetails?.JDEOrderType : this.taskDetail?.JDEOrderType,
        JDECompany: this.newTask ? this.orderDetails?.JDECompany : this.taskDetail?.JDECompany,
      })
    );
  }

  // Method to load all attachments
  loadAllAttachments(attachments?: any) {
    this.allAttachments = attachments;
  }

  navigateToOpenTask() {
    this.router.navigate(['/central/tasks']);
  }

  assignToMysite() {
    this.changeAssigneeForm.patchValue({
      site: this.userSite?.sourceSiteCode,
      storeType: this.siteList?.find((site) => site.siteCode === this.userSite?.sourceSiteCode).siteType === 'ARB' ? '0' : '1',
      assignedTo: 'UNASSIGNED',
    });
  }

  assignToMe() {
    const assignTo = this.salesPersonList.find((el) => el.name === this.loggedInUser)?.userEmail;
    this.changeAssigneeForm.patchValue({
      assignedTo: assignTo,
      assignedToName: this.loggedInUser,
      site: this.homeSite,
      storeType: this.siteList?.find((site) => site.siteCode === this.userSite?.sourceSiteCode).siteType === 'ARB' ? '0' : '1',
    });
  }
}

